
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"60","height":"33.85","x":"10","y":"36.15","fill":"#FEA7B8","rx":"6"}}),_c('path',{attrs:{"fill":"#FD6481","d":"M10 18.46c0-1.7 1.22-3.08 2.73-3.08h54.54c1.5 0 2.73 1.38 2.73 3.08V30c0 1.7-1.22 3.08-2.73 3.08H12.73C11.23 33.08 10 31.7 10 30V18.46z"}}),_c('path',{attrs:{"fill":"#FD6481","d":"M27.05 13.08c0-1.7 1.22-3.08 2.72-3.08 1.5 0 2.73 1.38 2.73 3.08v3.07c0 1.7-1.22 3.08-2.73 3.08-1.5 0-2.72-1.38-2.72-3.08v-3.07zm21.81 0c0-1.7 1.22-3.08 2.73-3.08 1.5 0 2.73 1.38 2.73 3.08v3.07c0 1.7-1.22 3.08-2.73 3.08-1.5 0-2.73-1.38-2.73-3.08v-3.07z"}})])
          )
        }
      }
    